import { render, staticRenderFns } from "./WhitelabelSettingsGroup.vue?vue&type=template&id=34d8d7c7&scoped=true&"
import script from "./WhitelabelSettingsGroup.vue?vue&type=script&lang=ts&"
export * from "./WhitelabelSettingsGroup.vue?vue&type=script&lang=ts&"
import style0 from "./WhitelabelSettingsGroup.vue?vue&type=style&index=0&id=34d8d7c7&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d8d7c7",
  null
  
)

export default component.exports